import { useMemo } from "react";
import { atom, useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";

import { ParticipantsData, ReceivedInvitationType, RoomInformation } from "../../types";

const roomData = atom<RoomInformation>({
  key: "roomData",
  default: {
    accessToken: "",
    channelName: "",
    tokenType: "",
    uid: 0,
  },
});

export const useRoomDataState = () => useRecoilState(roomData);
export const useRoomDataValue = () => useRecoilValue(roomData);
export const useSetRoomData = () => useSetRecoilState(roomData);

const participantsData = atom<ParticipantsData>({
  key: "participantsData",
  default: {},
});

export const useParticipantsDataState = () => useRecoilState(participantsData);
export const useParticipantsDataValue = () => useRecoilValue(participantsData);
export const useParticipantsDataIds = () => {
  const participantsData = useParticipantsDataValue();
  const participantsIds = useMemo(() => Object.keys(participantsData).map((key) => Number(key)), [participantsData]);

  return participantsIds;
};

const isFirstSearch = atom<boolean>({
  key: "isFirstSearch",
  default: true,
});

export const useIsFirstSearchValue = () => useRecoilValue(isFirstSearch);
export const useSetIsFirstSearch = () => useSetRecoilState(isFirstSearch);

const invite = atom<ReceivedInvitationType | undefined>({
  key: "invite",
  default: undefined,
});

export const useInviteState = () => useRecoilState(invite);
export const useInviteValue = () => useRecoilValue(invite);
export const useSetInvite = () => useSetRecoilState(invite);

const participantLeftId = atom<number>({
  key: "participantsLeftId",
  default: 0,
});

export const useParticipantLeftIdState = () => useRecoilState(participantLeftId);
export const useParticipantLeftIdValue = () => useRecoilValue(participantLeftId);
export const useSetParticipantLeftId = () => useSetRecoilState(participantLeftId);

const networkQuality = atom<Record<number, boolean>>({
  key: "networkQuality",
  default: {},
});

export const useNetworkQualityState = () => useRecoilState(networkQuality);
export const useNetworkQualityValue = () => useRecoilValue(networkQuality);
